import { useEffect, useState } from "react";

import { computeErrors, intersectErrors, type UIRuleError } from "./ruleErrors";
import type { QRule } from "@coreapp/CoreApp/QRule";

export const useRuleErrors = (rule: QRule | null) => {
  const [errors, setErrors] = useState<UIRuleError | null>(null);

  useEffect(() => {
    setErrors(prev => {
      if (!prev || !rule) return null;
      return intersectErrors(prev, computeErrors(rule));
    });
  }, [rule]);

  const validate = (): boolean => {
    if (!rule) return true;
    const e = computeErrors(rule);
    if (e.hasError) {
      setErrors(e);
      return false;
    }
    return true;
  };

  const reset = () => setErrors(null);

  return { errors, validate, reset };
};
